import { useMemo } from 'react';

import ApiCalls from '../../components/api/apiCalls';
import TaskTypesService from '../../components/services/TaskTypesService';

const useTaskTypesService = () => {
  return useMemo(() => new TaskTypesService(new ApiCalls()), []);
};

export default useTaskTypesService;
